import { render, staticRenderFns } from "./adCampaignsDialog.vue?vue&type=template&id=b465be1a"
import script from "./adCampaignsDialog.vue?vue&type=script&lang=js"
export * from "./adCampaignsDialog.vue?vue&type=script&lang=js"
import style0 from "./adCampaignsDialog.vue?vue&type=style&index=0&id=b465be1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports